import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { usePermission } from "../../hooks/usePermission";
import { useApplicationContext } from "../../context/ApplicationContext";

const PrivatePermissionRoute = ({ permission, permissions }) => {
  const { hasPermission } = usePermission();
  const { auth } = useApplicationContext();
  const location = useLocation();

  if (!auth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const allowed = Array.isArray(permissions)
    ? permissions.some((p) => hasPermission(p))
    : hasPermission(permission);

  if (allowed) {
    return <Outlet />;
  } else {
    toast.error("Access denied! You don't have permission to access this route.", { 
      autoClose: 5000,
      toastId: "access-denied" // Prevent duplicate toasts
    });
    return <Navigate to="/dashboard" />;
  }
};

export default PrivatePermissionRoute;
